import styled from "styled-components";
import Image from "../Image";
import { colors, media } from "../../style/constants";

export const Wrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  padding: 1rem;
  width: 100%;
  ${media.md`
  padding: 3rem;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  `}
  ${media.sm`
     padding: 1.5rem; 
  `}
`;

export const StyledImage = styled(Image)`
  /* grid-row: span 3;
  grid-column: span 4;
  background: ${colors.blue900};
  position: relative;
  overflow: hidden;*/
  outline: 1px rgba(255, 255, 255, 0.5) solid;

  &.img1 {
    /* grid-row: span 2; */
  }

  &.img2 {
    /* grid-row: span 2; */
    ${media.md`
    /* grid-row: span 1; */
  `}
  }
  &.img3 {
    grid-column: span 2;
    ${media.md`
    grid-column: span 1;
  `}
  }

  img {
    width: 100%;
    object-fit: cover;
    ${media.sm`
    `}
  }

  ${media.md`
  
  `}
  ${media.sm`
  /* grid-column: span 8; */
    
    &:before {
      /* padding-top: 100%; */
    }
  `}
`;

export const InfoWrapper = styled.header`
  /* grid-row: 5 / 5;
  grid-column: 2 / 6;
  z-index: 3;
  align-self: center; */
  ${media.md`
  /* grid-row: 5 / 6;
    grid-column: 1 / 5;
    align-self: end; */
  `}
  ${media.sm`
    
    /* padding: 0 2rem; */
  `}
`;



// WEBPACK FOOTER //
// ./src/components/ImageSection/style.js